import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  arrayPush,
  change,
  getFormSyncErrors,
  getFormValues,
  submit,
} from 'redux-form';
import styled from 'styled-components';
import Button from '../../components/Button';
import Loader from '../../components/Loader';
import SectionSeparator from '../../components/SectionSeparator';
import { getProp, __ } from '../../utilities';
import { errorAlert, setStep } from '../App/actions';
import { passangerNumberSelector, ticketTypeSelector } from '../App/selectors';
import { paramsSelector } from '../Connections/selectors';
import FavouritePassengers from '../FavouritePassengers';
import { loadMyFavouritePassengers } from '../FavouritePassengers/actions';
import { userDetailSelector } from '../Login/selectors';
import {
  firstWayConnectionIdSelector,
  isSeatingInWaysInSectorsSelector,
  secondWayConnectionIdSelector,
} from '../Reservation/selectors';
import { loadTickets } from './actions';
import Form, { FORM_NAME } from './form';
import { ticketsIsFetchingSelector } from './selectors';

const Wrapper = styled.div`
  max-width: ${rem(801)};
  margin: 0 auto;
`;

export const BackButton = styled.button`
  color: ${({ theme }) => theme.color.font.primary};
  border: none;
  outline: none;
  background-color: transparent;
  text-decoration: underline;
  font-size: ${rem(14)};
  margin: 0 ${rem(49)};
  &:hover {
    cursor: pointer;
  }
`;

class Passengers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      favouritePassengersOpened: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    const {
      dispatch,
      user,
      ticketType,
      connectionId1,
      connectionId2,
      params: { count },
    } = this.props;

    const passengers = getProp(
      this.props,
      ['passengerFormData', 'passengers'],
      [],
    );

    dispatch(loadMyFavouritePassengers());
    dispatch(loadTickets(ticketType, connectionId1, connectionId2));

    if (!passengers || passengers.length === 0) {
      // ak nemame ziadneho cestujuceho, dame aspon toho prveho
      dispatch(
        arrayPush(FORM_NAME, 'passengers', {
          name: getProp(user, ['username'], ''),
          surname: getProp(user, ['surname'], ''),
          email: getProp(user, ['email'], ''),
          phone: getProp(user, ['contact'], ''),
        }),
      );
    }

    if (
      user &&
      passengers.length > 0 &&
      Object.keys(passengers[0]).length === 0
    ) {
      this.props.dispatch(
        change(FORM_NAME, 'passengers.0.name', getProp(user, ['username'])),
      );
      this.props.dispatch(
        change(FORM_NAME, 'passengers.0.surname', getProp(user, ['surname'])),
      );
      this.props.dispatch(
        change(FORM_NAME, 'passengers.0.email', getProp(user, ['email'])),
      );
      this.props.dispatch(
        change(FORM_NAME, 'passengers.0.phone', getProp(user, ['contact'])),
      );
    }

    if (!passengers || count > passengers.length) {
      // ak vyberieme v uvodnom vyhladavacom formulari viac cestujucich, ako aktualne mame vo formulari
      // dogenerujeme zvysnych
      for (
        let passengerIdx = passengers ? passengers.length : 0;
        passengerIdx < count - 1;
        passengerIdx++
      ) {
        dispatch(arrayPush(FORM_NAME, 'passengers', {}));
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { user: newUser } = nextProps;
    const { user } = this.props;
    if (user !== newUser) {
      nextProps.dispatch(
        change(FORM_NAME, 'passengers.0.name', getProp(newUser, ['username'])),
      );
      nextProps.dispatch(
        change(
          FORM_NAME,
          'passengers.0.surname',
          getProp(newUser, ['surname']),
        ),
      );
      nextProps.dispatch(
        change(FORM_NAME, 'passengers.0.email', getProp(newUser, ['email'])),
      );
      nextProps.dispatch(
        change(FORM_NAME, 'passengers.0.phone', getProp(newUser, ['contact'])),
      );
    }
  }

  submit(noSeating = false) {
    const {
      formErrors,
      isSeating,
      dispatch,
      passengerFormData: { passengers },
    } = this.props;

    dispatch(submit(FORM_NAME));

    if (Object.keys(formErrors).length > 0) {
      dispatch(
        errorAlert(
          __(
            'Vyplňte prosím všetky povinné polia a zvoľte tarifu pre každého cestujúceho',
          ),
        ),
      );
      return;
    }
    if (noSeating) {
      dispatch(setStep('summary', { for: 'passengers', info: passengers }));
    } else if (isSeating) {
      dispatch(
        setStep('reservations', { for: 'passengers', info: passengers }),
      );
    } else {
      dispatch(setStep('summary', { for: 'passengers', info: passengers }));
    }
  }

  handleSubmit() {}

  handleFavouritePassengersSelected = passengers => {
    const { dispatch } = this.props;
    if (passengers.length > 0) {
      passengers.forEach(passenger => {
        dispatch(
          arrayPush(FORM_NAME, 'passengers', {
            name: passenger.username,
            surname: passenger.surname,
          }),
        );
      });
    }
    this.setState({ favouritePassengersOpened: false });
  };

  render() {
    return (
      <Wrapper>
        <SectionSeparator content={__('Vyplňte informácie o cestujúcich')} />
        <Form
          onSubmit={this.handleSubmit}
          onClickAddFavouritePassengers={() => {
            this.setState({ favouritePassengersOpened: true });
          }}
        />

        <SectionSeparator
          content={[
            <React.Fragment>
              {this.props.ticketsIsFetching ? (
                <Loader />
              ) : (
                <React.Fragment>
                  <BackButton basic primary onClick={this.props.backStep}>
                    {__('Späť')}
                  </BackButton>
                  <Button primary onClick={() => this.submit(false)}>
                    {__('Pokračovať')}
                  </Button>
                  {this.props.isSeating && (
                    <Button basic primary onClick={() => this.submit(true)}>
                      {__('Pokračovať bez výberu miestenky')}
                    </Button>
                  )}
                </React.Fragment>
              )}
            </React.Fragment>,
          ]}
        />

        {this.state.favouritePassengersOpened && (
          <FavouritePassengers
            onSelect={this.handleFavouritePassengersSelected}
            onClose={() => {
              this.setState({ favouritePassengersOpened: false });
            }}
          />
        )}
      </Wrapper>
    );
  }
}

Passengers.propTypes = {
  dispatch: PropTypes.func.isRequired,
  ticketType: PropTypes.string.isRequired,
  user: PropTypes.shape({}),
  connectionId1: PropTypes.string.isRequired,
  connectionId2: PropTypes.string,
  backStep: PropTypes.func,
  isSeating: PropTypes.bool.isRequired,
  ticketsIsFetching: PropTypes.bool.isRequired,
};

Passengers.defaultProps = {
  user: {},
  backStep: () => {},
  connectionId2: undefined,
};

const mapStateToProps = state => {
  return {
    formErrors: getFormSyncErrors(FORM_NAME)(state),
    isSeating: isSeatingInWaysInSectorsSelector(state),
    ticketType: ticketTypeSelector(state),
    connectionId1: firstWayConnectionIdSelector(state),
    connectionId2: secondWayConnectionIdSelector(state),
    passangerNumberSelector: passangerNumberSelector(state),
    user: userDetailSelector(state),
    passengerFormData: getFormValues(FORM_NAME)(state),
    ticketsIsFetching: ticketsIsFetchingSelector(state),
    params: paramsSelector(state),
  };
};

export default connect(mapStateToProps)(Passengers);



// WEBPACK FOOTER //
// ./src/containers/Passengers/index.js